<template>
  <div>
    <h6 class="title-section">{{ $t("class-teacher.sub-titulo-tab") }}</h6>
    <TeacherNextClass />
    <div class="card pt-5 px-5 pb-4">
      <b-form inline class="mb-3">
        <b-form-group class="mr-2" style="max-width: 30%">
          <v-autocomplete
            placeholder="Student's name "
            :items="items"
            v-model="item"
            :min-len="0"
            :get-label="getLabel"
            :component-item="template"
            @update-items="updateItems"
            :auto-select-one-item="false"
          >
          </v-autocomplete>
        </b-form-group>
        <b-form-group
          class="mb-0 mt-auto pb-1 ml-auto"
          id="group-radio-student"
          style="width: 18%; max-width: 180px"
        >
          <b-form-radio
            class="m-auto"
            :value="true"
            v-model="typeStudent"
            name="CurrentStudent"
            @change="getListStudens()"
            >Current students</b-form-radio
          >
        </b-form-group>
        <b-form-group
          class="mb-0 mt-auto pb-1"
          id="group-radio-student"
          style="width: 19%; max-width: 180px"
        >
          <b-form-radio
            class="m-auto"
            :value="false"
            v-model="typeStudent"
            name="PreviousStudent"
            @change="getListStudens()"
            >Past students</b-form-radio
          >
        </b-form-group>
      </b-form>

      <b-table-simple responsive :aria-busy="isBusy">
        <b-thead>
          <b-th class="text-left" style="width: 150px">Student</b-th>
          <b-th>Hours Used</b-th>
          <b-th>Expiration Date</b-th>
          <b-th style="width: 230px">Courses</b-th>
          <b-th>Schedule</b-th>
          <b-th>Class Reports</b-th>
          <b-th>Assignments & Evaluations</b-th>
          <b-th>Monthly Report</b-th>
          <b-th>Chat</b-th>
        </b-thead>
        <b-tbody>
          <b-tr v-if="isBusy" class="b-table-busy-slot">
            <b-td colspan="10">
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> {{ $t("ClassRequest.Loading") }}...</strong>
              </div>
            </b-td>
          </b-tr>
          <b-tr v-else>
            <b-td colspan="10" v-if="itemsTable.length == 0">{{
              $t("reusables.empty-text")
            }}</b-td>
          </b-tr>
          <b-tr
            v-for="(row, i) of itemsTable"
            :key="i"
            :class="row.isGroup ? 'row-group' : ''"
          >
            <b-td
              class="text-left"
              :data-text-group="row.group"
              v-if="row.isGroup"
            >
              <div
                class="container-row-table"
                v-for="(student, s) of row.student"
                :key="s"
              >
                <span
                  style="cursor: pointer"
                  @click="getCoursesHistoryGroup(student, row)"
                  >{{ student.name }}
                </span>
              </div>
            </b-td>
            <b-td class="text-left" v-else>
              <div class="container-row-table">
                <span
                  style="cursor: pointer"
                  @click="getCoursesHistoryGroup(row.student[0], row)"
                  >{{ row.student[0].name }}
                </span>
              </div>
            </b-td>

            <b-td v-if="row.totalHoursSchedule >= 0 && row.duration > 0">
              <svg
                class="circle-chart"
                viewBox="0 0 36.83098862 36.83098862"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  class="circle-chart__background"
                  cx="17.9"
                  cy="18.9"
                  r="15.9"
                ></circle>
                <circle
                  v-if="row.totalHoursSchedule > 0"
                  class="circle-chart__circle warning-stroke"
                  :stroke-dasharray="row.percentageCompleted"
                  cx="17.9"
                  cy="17.9"
                  r="15.9"
                ></circle>
                <g class="circle-chart__info">
                  <text class="circle-chart__text" x="18" y="15.5">
                    {{ row.totalHoursSchedule + "/" + row.duration }}
                  </text>
                  <text class="circle-chart__text" x="18" y="22">hours</text>
                </g>
              </svg>
            </b-td>
            <b-td v-else> - </b-td>
            <b-td>{{ row.expirationDate }}</b-td>
            <b-td>{{ row.courses }}</b-td>
            <b-td>
              <div class="table-icon" v-if="typeStudent">
                <span
                  @click="
                    getListScheduleClass(
                      row.groupId,
                      row.groupScheduleStudentId
                    )
                  "
                  ><img src="@/assets/icons/icon-calendar.svg" class="svg"
                /></span>
                <span class="dot" v-if="row.counterProposalTeacher"></span>
                <!-- CIRCULO ROJO -->
                <!-- <span class="dot">1</span> -->
              </div>
              <div class="table-icon" v-else>
                <span>-</span>
              </div>
            </b-td>
            <b-td>
              <div
                class="table-icon"
                v-if="row.classReport >= 0"
                @click="getClassReport(row)"
              >
                <img
                  src="@/assets/icons/icon-statistical-result.svg"
                  class="svg"
                />
                <span class="dot" v-if="row.classReport > 0">{{
                  row.classReport
                }}</span>
              </div>
              <div class="table-icon" v-else>
                <span>-</span>
              </div>
            </b-td>
            <b-td>
              <div
                class="container-row-table"
                v-for="(iAssignment, index) in row.assignments"
                :key="`assignments-${index}`"
              >
                <div class="table-icon" v-if="iAssignment.assignment == '-'">
                  <span>-</span>
                </div>
                <div
                  class="table-icon"
                  v-else
                  @click="goEvaluationReports(1, row, iAssignment)"
                >
                  <img src="@/assets/icons/icon-valid-doc.svg" class="svg" />
                  <span v-if="iAssignment.assignment > 0" class="dot">{{
                    iAssignment.assignment
                  }}</span>
                </div>
              </div>
            </b-td>
            <b-td>
              <span></span>
              <div
                class="container-row-table"
                v-for="(iReport, index) in row.report"
                :key="`report-${index}`"
              >
                <div class="table-icon" v-if="iReport.report == '-'">
                  <span>-</span>
                </div>
                <div
                  class="table-icon"
                  v-else
                  @click="goEvaluationReports(0, row, iReport)"
                >
                  <img src="@/assets/icons/icon-result-note.svg" class="svg" />
                  <span v-if="iReport.report > 0" class="dot">{{
                    iReport.report
                  }}</span>
                </div>
              </div>
            </b-td>
            <b-td>
              <div
                class="table-icon"
                v-if="row.chat >= 0"
                @click="redirectChat(row.groupId)"
              >
                <img src="@/assets/icons/icon-comments.svg" class="svg" />
                <span class="dot" v-if="row.chat > 0">{{ row.chat }}</span>
              </div>
              <div class="table-icon" v-else>
                <span>-</span>
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="overflow-auto content-pagination" style="display: flex">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="pageSize"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
        {{ (currentPage - 1) * pageSize + 1 }} -
        {{
          pageSize > totalRows
            ? totalRows
            : pageSize * currentPage > totalRows
            ? totalRows
            : pageSize * currentPage
        }}
        /{{ totalRows }} items
      </div>
    </div>
    <b-modal id="modal-next-linkClass" :centered="true">
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <p class="text-center mb-0">{{ messageLinkClassResult }}</p>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('modal-next-linkClass')"
          variant="primary"
          >Aceptar</b-button
        >
      </template>
    </b-modal>
    <!--:key="`teacher-modal-schedule`" -->
    <viewCalendarStudent ref="calendarStudent" @list-studens="getListStudens" />
  </div>
</template>
<script>
let cancelToken;
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import ItemTemplate from "@/views/teacher/class/ItemTemplate ";
import TeacherNextClass from "./nextClass";
import viewCalendarStudent from "@/components/modals/ModalCalendarStudent";
import * as tools from "@/assets/js/tools.js";
export default {
  components: {
    TeacherNextClass,
    viewCalendarStudent,
  },
  data() {
    return {
      lang: localStorage.getItem("lang"),
      messageLinkClassResult: null,
      filterStudent: "",
      currentPage: 1,
      pageSize: 5,
      totalRows: 0,
      transProps: {
        // Transition name
        name: "flip-list",
      },
      pTotalDetail: 0,
      isBusy: false,
      typeStudent: true,
      optionsReport: [],
      optionsStatus: [],
      selectedStatus: null,
      selectedReport: null,
      itemsTable: [],
      dateRange: { startDate: null, endDate: null },
      /*value: '',
            suggestionAttribute: 'descripcion',
            suggestions: [],
            selectedEvent: "",*/
      item: null,
      items: [],
      template: ItemTemplate,
    };
  },
  props: {
    filterGroupId: Number,
    filterNameStudent: String,
  },
  computed: {
    groupId: {
      get() {
        return this.$store.state.group_id;
      },
      set(value) {
        this.$store.commit("mutateGroupId", value);
      },
    },
    User: {
      get() {
        return this.$store.state.user;
      },
    },
  },
  watch: {
    currentPage() {
      this.isBusy = true;
      this.getListStudens();
    },
  },
  created() {
    if (this.filterGroupId) {
      this.item = {
        id: this.filterGroupId,
        name: this.filterNameStudent,
      };
    }
    let startDate = this.$moment().toDate();
    let endDate = this.$moment().subtract(1, "months").toDate();
    this.dateRange = {
      startDate: endDate,
      endDate: startDate,
    };
    this.isBusy = true;
    //this.getListClassTeacher();
    this.getListStudens();
  },
  updated() {
    if (this.$store.state.user != null) {
      this.$store.state.user.totalDetail = this.pTotalDetail;
      this.$store.commit("mutateUser", this.$store.state.user);
    }
  },
  mounted() {
    this.$nextTick(function () {
      tools.imgToSvg();
    });
  },
  methods: {
    getLabel(item) {
      this.item = item;
      this.getListStudens();
      return item?.name;
    },
    getListStudens() {
      this.isBusy = true;
      let data = {
        studentName: this.item ? this.item.name : null,
        tearcherid: this.User.personTeacherId,
        typeStudents: this.typeStudent,
        Page: this.currentPage,
        Size: this.pageSize,
      };

      this.itemsTable = [];
      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsStudents/ListByStudens`, {
          params: data,
        })
        .then((response) => {
          this.pTotalDetail = response.data.value;
          if (this.$store.state.user != null) {
            const updatedUser = {
              ...this.$store.state.user,
              totalDetail: response.data.value,
            };
            this.$store.commit("mutateUser", updatedUser);
          }

          response.data.list.forEach((element) => {
            let data = {
              id: element.id,
              groupId: element.groupId,
              groupScheduleStudentId: element.groupScheduleStudents.id,
              group: element.group.code,
              level: element.group.levels.name,
              courses: element.group.strSubjects_EN.replaceAll("|", "\n"),
              classReport: element.classrReports,
              chat: element.chatTotal,
              student: [],
              assignments: [],
              report: [],
              isGroup: element.isGroup,
              totalHoursSchedule: element.totalHoursSchedule,
              duration: element.duration,
              percentageCompleted: `${element.percentHoursCompleted}, 100`,
              percentHoursCompleted: element.percentHoursCompleted,
              counterProposalTeacher: element.counterProposalTeacher,
              expirationDate: element.strExpirationDate || "-",
            };

            let studentsIds = element.group.studentsIds.split("|");
            let student = element.group.strStudents.split("|");
            let assignments = [];
            let report = [];

            if (
              element.strAssignmentsEvaluations != "" ||
              element.strAssignmentsEvaluations == "-"
            ) {
              assignments = element.strAssignmentsEvaluations.split("|");
            }

            if (
              element.strStudentReports != "" ||
              element.strStudentReports == "-"
            ) {
              report = element.strStudentReports.split("|");
            }
            for (const index in studentsIds) {
              data.student.push({
                studentId: studentsIds[index],
                name: student[index],
              });

              data.assignments.push({
                studentId: studentsIds[index],
                assignment:
                  assignments[index] == undefined ? "-" : assignments[index],
              });
              data.report.push({
                studentId: studentsIds[index],
                report: report[index] == undefined ? "-" : report[index],
              });
            }

            this.itemsTable.push(data);
          });

          this.totalRows = response.data.rows;
          this.isBusy = false;
          this.$nextTick(function () {
            tools.imgToSvg();
          });
        });
    },
    updateItems(text) {
      let params = {
        Id: this.User.personTeacherId,
        Filter: text,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/ComboStudentClassByAutocomplete`,
          { params }
        )
        .then((response) => {
          if (response.data && response.data.list) {
            this.items = response.data.list.map((x) => ({
              id: x.id,
              name: x.descripcion,
            }));
          }
        });
    },
    getValidationColumnReport(state, groupPlanClassId) {
      let textReturn = "";

      switch (state) {
        case Constants.CALENDAR_STATUS.PENDIENT.VALUE:
        case Constants.CALENDAR_STATUS.CONFIRM.VALUE:
        case Constants.CALENDAR_STATUS.UNAVAILABLE.VALUE:
          textReturn = "";
          break;
        case Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE:
        case Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE:
          textReturn = "-";
          break;
        case Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE:
        case Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE:
          textReturn = groupPlanClassId ? "See" : "Enter";
          break;
        case Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE:
          textReturn = "Enter";
          break;
        case Constants.CALENDAR_STATUS.COMPLETED.VALUE:
          textReturn = "See";
          break;
      }

      return textReturn;
    },
    getClassReport(data) {
      this.$router
        .push({
          name: "teacher-class-list-report",
          params: {
            filterGroupId: data.groupId,
            filterNameStudent: this.TabClassRequest ? data.student : data.group,
            pIsGroup: data.isGroup,
            pStudent: data.student,
            pCodeGroup: data.group,
            pTotalHoursSchedule: this.typeStudent ? data.totalHoursSchedule : 0,
            pDuration: this.typeStudent ? data.duration : 0,
            pPercentageCompleted: data.percentHoursCompleted,
            pFlagRegistroClass: false,
          },
        })
        .catch(() => {});
    },
    getListScheduleClass(groupId, groupScheduleStudentId) {
      let data = {
        groupId: groupId,
        groupScheduleStudentId: groupScheduleStudentId,
      };
      this.$refs.calendarStudent.getShowCalendar(data);
    },
    goEvaluationReports(value, item, data) {
      this.$router.push({
        name: "teacher-student-evaluations-reports",
        params: {
          id: value,
          flagHistory: this.typeStudent ? false : true,
          disabledTab: 1, //deshabilita evaluacion,
          groupId: item.groupId,
          personStudentId: parseInt(data.studentId),
          flagTab: false,
          TabClassRequest: this.TabClassRequest,
          typeStudent: this.typeStudent,
        },
      });
    },
    redirectChat(idGroup) {
      if (this.typeStudent) {
        this.$router.push({ name: "chat", params: { filterGroupId: idGroup } });
      }
    },
    getCoursesHistoryGroup(item, data) {
      this.$router.push({
        name: "teacher-student-courseHistory",
        params: {
          id: parseInt(item.studentId),
          name: item.name,
          groupId: data.groupId,
        },
      });
    },
  },
};
</script>
<style>
th {
  white-space: normal;
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-family: monospace;
  font-size: 20px;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  overflow: scroll;
  max-height: 200px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #ddd;
}
</style>
